const NoFoundPage = () => {
  return (
    <div>NoFoundPage</div>
  )
}

export default NoFoundPage